<template>
    <div class="panel">
      <div class="panel-header flex justify-between">
        <div class="flex justify-content gap-2 items-center">
          <v-icon name="co-warning" height="1em" width="1em" scale="1"/>
          <span>Are you sure?</span>
        </div>
        <button @click="emitClose">
          <v-icon name="io-close" />
        </button>
      </div>
      <div class="panel-body text-sm"> 
        <div class=" mb-3 font-bold">This action cannot be undone.</div>
        <div class="">
          Please confirm you'd like to delete the following postback:
          <div class="flex my-3 flex-col gap-2">
            <div><span class="font-medium  mr-2">URL:</span> {{ postback.fullUrl }}</div>
          </div>
        </div>
        <div class="flex justify-between mt-6">
          <XButton
            class="bg-rose-500 !border-transparent hover:bg-rose-600 focus:bg-rose-600  text-white w-full"
            @click="update"
            :isLoading="isSubmitting"
          >Delete</XButton>
        </div>
      </div>
  
     
    </div>
  </template>
  
  
  <script setup lang="ts">

  interface Postback {
    id: number | string;
    url: string;
    fullUrl: string;
    conversionType: string;
  }


  import { ref, defineProps, defineEmits } from 'vue'
  import DELETE_POSTBACK_MUTATION from '@/graphql/Postback/DeletePostbackMutation.gql'
  import { useMutation } from '@vue/apollo-composable'
  import POSTBACKS_QUERY from "@/graphql/Postback/Postbacks.gql"

  // import { useToast } from "@meforma/vue-toaster";

  // const toast = useToast();
  
  const props = defineProps<{ postback: Postback, campaignId?: string | number }>();

  const emit = defineEmits(['close'])
  
  const isSubmitting = ref(false)
  
  function emitClose() {
    emit('close')
  }

  const { mutate: deletePostback, loading } = useMutation(DELETE_POSTBACK_MUTATION, {
    update(cache, { data } ) {
      cache.evict({ id: cache.identify(data.deletePostback) })
      if (props.campaignId) {
        cache.evict({ id: `PublisherCampaign:${props.campaignId}` })
      }
      cache.evict({fieldName: 'postbacks'})
      cache.gc()
    },
  })
  
  


  async function update() {
    isSubmitting.value = true

      deletePostback({
        id: props.postback.id,
      }).then(({ data }) => {
        isSubmitting.value = true
        emitClose()
      }).catch(error => {
        emitClose()
        isSubmitting.value = true
      })

  }
  </script>
  
  <style scoped>
  .text-opacity-light {
    opacity: 0.7;
  }
  .bg-danger .text-warning {
    color: #ffd800 !important;
  }
  .bg-dark-transparent-1 {
    background: rgba(0, 0, 0, 0.1);
  }
  </style>